import http from '@/plugins/axios/axios';

export default class CentroCustoService {

    salvarDepartamento(requisicao) {       
        return http.post('/api/centro-custo/salvar-departamento', requisicao);
    }

    salvarSetorSecao(requisicao) {       
        return http.post('/api/centro-custo/salvar-setor-secao', requisicao);
    }

    alterar(requisicao) {       
        return http.post('/api/centro-custo/alterar', requisicao);
    }

    excluir(requisicao) {       
        return http.post('/api/centro-custo/excluir', requisicao);
    }

    buscar(requisicao) {       
        return http.post('/api/centro-custo/buscar', requisicao);
    }
    
    listarCnpjs(requisicao) {       
        return http.post('/api/centro-custo/listar-cnpjs', requisicao);
    }   

    listarDepartamentos(requisicao) {       
        return http.post('/api/centro-custo/listar-departamentos', requisicao);
    }

    listarSetores(requisicao) {       
        return http.post('/api/centro-custo/listar-setores', requisicao);
    }

    listarSecoes(requisicao) {       
        return http.post('/api/centro-custo/listar-secoes', requisicao);
    } 
    
    listarTodos(requisicao) {       
        return http.post('/api/centro-custo/listar-todos', requisicao);
    } 

    listarCentrosCustosUsuario(requisicao) { 
        return http.post('/api/centro-custo/listar-centros-custos-usuario', requisicao);
    }
}